import { render, staticRenderFns } from "./ModernBarChart.vue?vue&type=template&id=5a254da7&scoped=true&"
import script from "./ModernBarChart.vue?vue&type=script&lang=js&"
export * from "./ModernBarChart.vue?vue&type=script&lang=js&"
import style0 from "./ModernBarChart.vue?vue&type=style&index=0&id=5a254da7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a254da7",
  null
  
)

export default component.exports